module.exports = __webpack_public_path__ + "static/001-slideshow-861dbf3c77e530e627bcd1e4846e2d98.jpg";